import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {UIAPIEndpoints} from '../../../../shared/scripts/network/UIAPIEndpoints'
import {Sound} from '../../../../shared/scripts/Sound'
import {getProfileURI} from '../../../../shared/scripts/ui_utils/TestableClientUtils'
import {UIPopupController} from '../../../../shared/scripts/ui_popup/UIPopupController'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIAjaxWrapper} from '../../../../shared/scripts/network/UIAjaxWrapper'
import {DropdownContent, UIComponentDropdownController} from '../../../../shared/scripts/ui_components/UIComponentDropdownController'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {tabCommunication} from '../../../../shared/scripts/EntryShared'
import {TabCommunicationEvent} from '../../../../shared/scripts/tab_communication/TabCommunication'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {StorageWrapper} from '../../../../shared/scripts/StorageWrapper'
import {navigateToPage} from '../../../../shared/scripts/ui_utils/ClientUtils.ts'
import {ViewPopupEditProfile} from '../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {UIWProfileUsernameController} from './UIWProfileUsernameController.ts'

export class UIHeaderProfileDropdownController extends UIComponentDropdownController {
    private readonly viewProfileButton: HTMLLinkElement
    private readonly editProfileButton: HTMLLinkElement
    private readonly logoutButton: HTMLLinkElement

    constructor(dropdownContent: DropdownContent[], dropdownParentId: string, toggleVisibilityComponent: HTMLDivElement) {
        const hideDropdown = false
        super(dropdownContent, dropdownParentId, hideDropdown, toggleVisibilityComponent)
        this.viewProfileButton = document.getElementById('header_profile_dropdown_view_profile') as HTMLLinkElement
        this.editProfileButton = document.getElementById('header_profile_dropdown_edit_profile') as HTMLLinkElement
        this.logoutButton = document.getElementById('header_profile_dropdown_logout') as HTMLLinkElement

        this.setButtonsActions()
    }

    private setButtonsActions() {
        this.viewProfileButton.onclick = () => {
            if(ClientUserState.userState == undefined) return
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedViewStats)
            if(!UIHeaderProfileDropdownController.loginCheck()) return

            navigateToPage(getProfileURI(ClientUserState.userState.username))
        }

        this.editProfileButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedEditProfile)
            if(!UIHeaderProfileDropdownController.loginCheck()) return

            new ViewPopupEditProfile({
                usernameController: UIWProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
            })
        }

        if(UIUtilsEjsVariables.isUserOnDiscord) return

        this.logoutButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedLogout)
            if(!ClientUserState.userState?.isLoggedIn) {
                new ViewPopupLogin()
                return
            }
            this.logoutAction()
        }
    }

    dropdownButtonAction() {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedDropdown)
        this.dropdownView.classList.toggle('show')
    }

    private static loginCheck(): boolean {
        if(ClientUserState.userState?.isLoggedIn) return true
        if(UIUtilsEjsVariables.isUserOnDiscord) return true
        new ViewPopupLogin()
        return false
    }

    private logoutAction() {
        UIPopupController.create({key: 'strings:homePage.header.logoutPopup.title'}, {key: 'strings:homePage.header.logoutPopup.body'},
            async() => {
                const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.logout(), undefined, undefined)
                if(response == undefined) return
                tabCommunication.sendEvent(TabCommunicationEvent.ReloadWebsite)
                StorageWrapper.clearUserState()
                location.reload()
            }, () => undefined)
        this.hideDropdownMenuIfShown()
    }
}
